var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H5.33333H16",
    stroke: "#DC3F16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.8V15.6C15 15.9713 14.8495 16.3274 14.5816 16.5899C14.3137 16.8525 13.9503 17 13.5714 17H6.42857C6.04969 17 5.68633 16.8525 5.41842 16.5899C5.15051 16.3274 5 15.9713 5 15.6V5.8M7.14286 5.8V4.4C7.14286 4.0287 7.29337 3.6726 7.56128 3.41005C7.82919 3.1475 8.19255 3 8.57143 3H11.4286C11.8075 3 12.1708 3.1475 12.4387 3.41005C12.7066 3.6726 12.8571 4.0287 12.8571 4.4V5.8",
    stroke: "#DC3F16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9V14",
    stroke: "#DC3F16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9V14",
    stroke: "#DC3F16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelet);
export default __webpack_public_path__ + "static/media/delet.608764337099f4f39ed4ae312ed43ab5.svg";
export { ForwardRef as ReactComponent };